import * as React from "react"
import type { SVGProps } from "react"
const SvgReviewSourcePlayStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.625 14.103 66.86 36.822l-9.74 9.31-32.325-30.908c-.581-.56.094-1.52.804-1.135zM19 81.58v-63.16a.696.696 0 0 1 1.184-.494L53.071 50 20.184 82.072A.695.695 0 0 1 19 81.579m5.799 3.198c-.585.559.09 1.52.803 1.134l.026-.014L66.86 63.178l-9.74-9.313zM71.992 39.64l11.515 6.342c3.132 1.73 3.132 6.305 0 8.036l-11.515 6.337L61.164 50z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgReviewSourcePlayStore
